import React, { useEffect, useRef, useState } from "react";
import "./OTPInputField.scss";

const OTPInputField = ({
  numberOfFields,
  required,
  disabled,
  setValue,
  register,
  name,
  inputErrors,
  reset,
}) => {
  const inputRef = useRef([]);

  const [codes, setCodes] = useState([]);
  const [prev, setPrev] = useState(false);

  useEffect(() => {
    const temp = [];
    for (let i = 0; i < numberOfFields; i++) {
      temp.push("");
    }
    inputRef.current[0] && inputRef.current[0].focus();
    setCodes(temp);
  }, [numberOfFields, reset]);

  const handleChange = (e, i) => {
    if (!prev) {
      let temp = [...codes];
      if (e.target.value !== "") {
        let value = Number(e.target.value) % 10;
        temp[i] = value;
        setCodes(temp);
        if (i !== numberOfFields - 1) {
          inputRef.current[i + 1].focus();
        }
      } else {
        temp[i] = "";
        setCodes(temp);
      }
    }
  };

  const handlePaste = (e) => {
    let value = (e.clipboardData || window.clipboardData).getData("Text");
    if (value.toString().length === inputRef.current.length && Number(value)) {
      let temp = [...codes];
      inputRef.current.forEach((el, i) => {
        temp[i] = value[i];
        el.focus();
      });
      setCodes(temp);
    }
  };

  useEffect(() => {
    inputRef.current[0] && inputRef.current[0].focus();
    register(name, { required });
  }, []);

  useEffect(() => {
    let value = "";
    for (let i = 0; i < numberOfFields; i++) {
      value = `${value}` + codes[i];
    }
    if (`${value}`.length === numberOfFields) {
      setValue(name, value);
    } else {
      setValue(name, null);
    }
  }, [codes]);

  useEffect(() => {
    if (inputErrors && inputErrors[name]) {
      if (inputErrors[name].type === "required") {
        let emptyIndex = null;
        for (let i = 0; i < numberOfFields; i++) {
          if (!codes[i]) {
            emptyIndex = i;
            break;
          }
        }
        if (emptyIndex !== null) {
          inputRef?.current[emptyIndex]?.focus();
        }
      }
    }
  }, [inputErrors]);

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace") {
      setPrev(true);

      const temp = [...codes];
      if (temp[index]) {
        temp[index] = "";
      } else if (index > 0) {
        temp[index - 1] = "";
      }
      setCodes(temp);
      index > 0 && inputRef?.current[index - 1]?.focus();
    } else {
      setPrev(false);
    }
  };  

  return (
    <div className="otp-input-fileds">
      {codes?.map((code, i) => {
        return (
          <input
            ref={(element) => {
              inputRef.current.push(element);
            }}
            placeholder=""
            value={code}
            type="number"
            onChange={(e) => {
              handleChange(e, i);
            }}
            key={i}
            min="0"
            max="9"
            disabled={disabled}
            onPaste={handlePaste}
            onKeyDown={(e) => {
              handleKeyDown(e, i);
            }}
          />
        );
      })}
      {inputErrors && inputErrors[name]?.type && (
        <p className="error">
          {inputErrors[name].type === "custom"
            ? inputErrors[name].message
            : inputErrors[name].type === "required"
            ? `All fields are required.`
            : `${name} input is not valid.`}
        </p>
      )}
    </div>
  );
};

export default OTPInputField;
